import React from "react";
import dr_img_1 from "../../assets/images/our-Team-1.jpg";
import dr_img_2 from "../../assets/images/Our-team.jpg";
import dr_img_3 from "../../assets/images/out-team-4.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import StarRateIcon from "@mui/icons-material/StarRate";
import quote from "../../assets/images/quote-img.png";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
const HomePageTestimonials = () => {
  const data = [
    {
      name: "Seeing Patients",
      image: dr_img_1,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_2,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_3,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_1,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_2,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_3,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_1,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_2,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
    {
      name: "Seeing Patients",
      image: dr_img_3,
      review:
        "Nuisuam est rui dolorem ipsum rui dolor sit amet, consectetur, adipise velit sed quia non numquam eiusm tempora incidunt ut labore",
    },
  ];

  return (
    <div className="flex flex-col items-center sm:py-28 py-14 px-4 relative">
      <div className="absolute top-20 right-20">
        <img
          loading="lazy"
          decoding="async"
          width="312"
          height="367"
          src="https://designingmedia.com/medwell/wp-content/uploads/2024/01/review-small-img.png"
          class="attachment-large size-large wp-image-6861"
          alt=""
          srcset="https://designingmedia.com/medwell/wp-content/uploads/2024/01/review-small-img.png 312w, https://designingmedia.com/medwell/wp-content/uploads/2024/01/review-small-img-255x300.png 255w"
          sizes="(max-width: 312px) 100vw, 312px"
        />
      </div>
      <div className="text-[#243FFA] text-[16px] text-center font-normal font-outfit">
        OUR TESTIMONIALS
      </div>
      <h2 className="xl:text-[52px] text-[32px] font-outfit text-center font-semibold z-20 text-[#0F2349]">
        What Patients are Saying!
      </h2>

      <div className="w-full max-w-screen-xl mt-12 sm:px-12 px-4">
        <Swiper
          modules={[Pagination]}
          spaceBetween={30}
          loop={true}
          grabCursor={true}
          centeredSlides={false}
          pagination={{ clickable: true, el: ".custom-swiper-pagination" }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="w-full"
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col bg-white   sm:pt-10 pt-5 pb-6 sm:px-8 px-2 rounded-xl "
              
              style={{
                boxShadow: "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
              }}
              >
                <figure className=" w-8  group mb-6 rounded-full overflow-hidden  ">
                  <img
                    src={quote}
                    alt={item.name}
                    className="w-full h-full object-cover  transition-all duration-300 group-hover:brightness-90 group-hover:contrast-110"
                  />
                </figure>

                <p
                  className="text-[#757887] text-sm sm:text-[18px] sm:text-left text-center font-outfit font-light 
                 mt-2"
                >
                  {item.review}
                </p>
                <div className="flex justify-center items-center mt-5 gap-4 mb-3">
                  <div className="flex-shrink-0">
                    <img
                      src={item.image}
                      className="w-12 h-12 rounded-full"
                      alt="image-testimonials"
                    />
                  </div>
                  <div>
                    <p className="text-yellow-400">
                      <StarRateIcon />
                      <StarRateIcon />
                      <StarRateIcon />
                      <StarRateIcon />
                      <StarRateIcon />
                    </p>
                    <p className="text-[#0F2349] text-lg font-semibold font-outfit ">
                      {item.name}
                    </p>
                    <p className="text-[#0F2349] text-sm font-normal font-outfit ">
                      Happy Client
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="custom-swiper-pagination mt-12 flex justify-center"></div>
      </div>
    </div>
  );
};

export default HomePageTestimonials;
